module.exports = __webpack_public_path__ + "img/stripe.4ddfb26e.svg";